import tokenConst from '@/constants/token';
import dayjs from 'dayjs';

export default {
    /**
   * @returns {number}
   */
    getTokenExpirationTimestamp () {
        const timestamp = parseInt(localStorage.getItem(tokenConst.TOKEN_EXPIRATION_KEY));

        return isNaN(timestamp) ? 0 : timestamp;
    },
    /**
   * @param {number} timestamp
   * @returns {this}
   */
    setTokenExpirationTimestamp (timestamp) {
        localStorage.setItem(tokenConst.TOKEN_EXPIRATION_KEY, timestamp.toString());

        return this;
    },
    /**
   * @returns {number}
   */
    getLastActivityTimestamp () {
        const timestamp = parseInt(localStorage.getItem(tokenConst.LAST_ACTIVITY_TIMESTAMP_KEY));

        return isNaN(timestamp) ? 0 : timestamp;
    },
    /**
   * @param timestamp
   * @returns {default}
   */
    setLastActivityTimestamp (timestamp) {
        localStorage.setItem(tokenConst.LAST_ACTIVITY_TIMESTAMP_KEY, timestamp.toString());

        return this;
    },
    /**
   * @returns {number}
   */
    getTokenTtl () {
        const currentTimestamp = dayjs().unix();
        const ttl = this.getTokenExpirationTimestamp() - currentTimestamp;

        return ttl < 0 ? 0 : ttl;
    },
    /**
   * @returns {number}
   */
    getInactivityTime () {
        return dayjs().unix() - this.getLastActivityTimestamp();
    },
    /**
   * @returns {number}
   */
    getTimeToLogout () {
        return tokenConst.INACTIVITY_TIME_LIMIT - this.getInactivityTime();
    },
    /**
   * @returns {number}
   */
    isTokenValid () {
        return this.getTokenTtl() > 0;
    },
    /**
   * @returns {number}
   */
    getTokenMaxTtl () {
        return tokenConst.TOKEN_MAX_TTL;
    },
    /**
   * @returns {boolean}
   */
    shouldRefreshToken () {
        return this.getTokenTtl() < this.getTokenMaxTtl() - tokenConst.TOKEN_TTL_REFRESH_TRIGGER;
    },
    /**
   * @returns {boolean}
   */
    shouldShowInactivityModal () {
        return (
            this.isTokenValid() && this.getInactivityTime() >= tokenConst.INACTIVITY_TIME_MODAL_TRIGGER
        );
    },
    /**
   * @returns {boolean}
   */
    isInactivityTimeoutExceeded () {
        return this.getInactivityTime() > tokenConst.INACTIVITY_TIME_LIMIT;
    }
};
